import SamplePartThumbnail from 'components/onboarding/sample-part-thumbnail'
import { useOnboarding } from 'context/onboarding-context'
import classNames from 'helpers/class-names'
import { FC, useState } from 'react'

interface Props {
  fileName: string
  thumbnail: string
  name: string
}

const SamplePart: FC<Props> = ({ fileName, thumbnail, name }) => {
  const [mouseOver, setMouseOver] = useState(false)
  let mouseOverTimeout: NodeJS.Timeout
  const { onboard, isCompleting } = useOnboarding()

  return (
    <button
      className={classNames(
        'group flex h-20 w-full transform flex-row overflow-hidden rounded-lg border border-gray-100 bg-white shadow outline-none ring-info/50 duration-300 ease-in-out hover:border-gray-200 hover:shadow-lg focus-visible:border-info focus-visible:shadow-none focus-visible:ring-2',
        { 'active:scale-95 active:shadow-none': !isCompleting },
      )}
      onMouseEnter={() => {
        mouseOverTimeout = setTimeout(() => setMouseOver(true), 500)
      }}
      onMouseLeave={() => {
        clearTimeout(mouseOverTimeout)
        setMouseOver(false)
      }}
      onClick={() => {
        if (!isCompleting) {
          onboard(fileName)
        }
      }}
      disabled={isCompleting}>
      <div className="relative block h-full w-16 shrink-0 bg-gray sm:w-24">
        <SamplePartThumbnail
          className="h-full w-full"
          endpoint={`/api/parts/samples/${fileName}/geometry`}
          thumbnail={thumbnail}
          mouseOver={mouseOver}
        />
      </div>
      <div className="flex h-full w-full flex-row items-center px-4 text-left">
        <div className="flex flex-col gap-px truncate">
          <span className="truncate text-sm font-bold text-gray-500">
            {name}
          </span>
          <span className="truncate text-xs font-semibold text-gray-300">
            By <strong className="font-bold">Team Toolpath</strong>
          </span>
        </div>
      </div>
    </button>
  )
}

export default SamplePart
